<template>
  <div class="controlOption">
    <div class="left">
      <span class="checkbox onoff">
        <!-- <input type="checkbox" id="check_tvcontrol" :checked="tvControl" @click.prevent="checkControl"> -->
        <input type="checkbox" id="check_tvcontrol" v-model="tvControl">
        <label for="check_tvcontrol">{{locale.tvcontrol}}</label>
      </span>
      <button v-if="tvControl" type="button" class="btn sizeXs toCapitalize" @click="setRemote">{{locale.tv_setting_controller}}</button>
      <span v-if="tvControl" class="sysMessage">{{locale.tv_control_info_message}}</span>
    </div>
    <div class="right">
      <button type="button" class="btn sizeXs toCapitalize" @click="setTvName">{{locale.tv_set_name}}</button>
    </div>
    <SetTvNames v-if="tvName"
      :locale="locale"
      :setting="setting"
      @close="setTvName" />
    <SetRemote v-if="remote"
      :locale="locale"
      :setting="setting"
      @closeRemote="setRemote" />
  </div>
</template>

<script>
import SetRemote from '@/components/Tv/SetRemote'
import SetTvNames from '@/components/Tv/SetTvNames'

export default {
  props: [
    'locale'
  ],
  components: {
    SetRemote,
    SetTvNames
  },
  computed: {
    setting () {
      return this.$store.getters['tv/getSetting']
    },
    tvControl: {
      get () {
        return this.setting.control
      },
      set (isControl) {
        const confirm = this.tvControl ? this.locale.confirm_save_disable : `${this.locale.tv_control_info_message}\n${this.locale.confirm_save_active}`
        if (window.confirm(confirm)) {
          this.$store.commit('tv/setSetting', { control: isControl })
          this.$store.dispatch('tv/setSetting', this.setting).then(() => {
            alert(this.locale.complete_application)
          })
        }
      }
    }
  },
  data () {
    return {
      remote: false,
      tvName: false,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    setRemote () {
      this.remote = !this.remote
    },
    setTvName () {
      this.tvName = !this.tvName
    }
  }
}
</script>
<style lang="scss" scoped>
.controlOption {
  display: flex;
  margin-bottom: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid $color-lgrey2;
  .checkbox.onoff label {
    opacity: 0.5;
  }
  .checkbox.onoff :checked + label {
    opacity: 1;
  }
  .right {
    margin-left: auto;
  }
}
</style>
